"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Rental Policies factory
 * formats the raw data into a usable format
 */
const get_1 = __importDefault(require("lodash/get"));
/**
 * Returns formatted rental policy data
 * @param {RentalPolicyType} policy
 * @param {string} language
 * @returns {RentalPolicyFactoryType}
 */
function rentalPolciesFactory(policy, language) {
    return {
        id: (0, get_1.default)(policy, 'id', -1),
        identifier: (0, get_1.default)(policy, 'identifier', ''),
        position: (0, get_1.default)(policy, 'position', -1),
        title: (0, get_1.default)(policy, `title.${language}`, ''),
        titleEn: (0, get_1.default)(policy, `title.en`, ''),
        subtitle: (0, get_1.default)(policy, `subtitle.${language}`, ''),
        description: (0, get_1.default)(policy, `description.${language}`, ''),
        enabled: (0, get_1.default)(policy, 'enabled', false),
    };
}
exports.default = rentalPolciesFactory;
